"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var executeScript = function executeScript(script) {
  try {
    // eslint-disable-next-line no-new-func
    new Function(script)();
  } catch (error) {
    console.error("Error executing script: ".concat(error.message));
  }
};

var _default = executeScript;
exports.default = _default;